import { Component, Input, OnInit } from '@angular/core';

interface IAcceptanceCardAppeareance {
  fontSize?: string;
  padding?: string;
  maxWidth?: string;
  alignItems?: string;
  iconWidth?: string;
  iconHeight?: string;
  svgWidth?: string;
}

@Component({
  selector: 'hr-digital-acceptance-card',
  templateUrl: './digital-acceptance-card.component.html',
  styleUrls: ['./digital-acceptance-card.component.scss'],
})
export class DigitalAcceptanceCardComponent implements OnInit {
  @Input() dataAceite!: any
  @Input() ipAssinante!: string;
  @Input() fullName!: string;
  @Input() customClass?: string;
  @Input() acceptanceCardAppeareance: IAcceptanceCardAppeareance = {};
  constructor() { }

  ngOnInit(): void {
    this.formatDate(this.dataAceite);
  }

  formatDate(date: Date) {
    if (this.dataAceite && typeof this.dataAceite.toDate === 'function') {
      this.dataAceite = this.dataAceite.toDate();
      return;
    }
    if (!(this.dataAceite instanceof Date)) {
      const parsed = new Date(this.dataAceite);
      this.dataAceite = isNaN(parsed.getTime()) ? new Date() : parsed;
    }
  }
}